import { Flow } from 'signup-constants/Flow';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { getFlowConfig, getFlowSteps } from '../../flow-initial/getFlowConfig';
import { getFlowKey } from '../../routing/getFlowKey';
import { Data } from '../../signup-data/DATA';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { setFlow } from '../../store/flow/action-creators';
import { setSignupDataValue } from '../../store/signup-data/action-creators';
import { Step } from '../../views/Step';
import { NextStepManager } from '../../flow-management/NextStepManager';
export const BranchACQ134VariantB = {
  name: 'BranchACQ134VariantB',
  stateCheck: state => {
    return getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0134, [ExperimentParameterGroup.Variant_B]);
  },
  rebuildFlow: (flow, state, dispatch) => {
    const flowKey = getFlowKey();
    let preVerification = [Step.Industry, Step.CompanySize, Step.ManagementLevel, Step.HubOption, Step.BusinessGoals, Step.AhaMoment, Step.LandingPage, Step.CodeVerification];

    if (flowKey !== Flow.Crm) {
      dispatch(setSignupDataValue(Data.HubOption, getFlowConfig().hubInterest));
      preVerification = NextStepManager.removeSteps(Step.HubOption)(preVerification);
    }

    const postVerification = [Step.Password, Step.Name, Step.CompanyInfo, Step.HubletSelection];
    const nextSteps = [...preVerification, ...postVerification];
    dispatch(setFlow(nextSteps, preVerification, postVerification, [], getFlowSteps().postExistingAccountSelection));
    return nextSteps;
  },
  processed: false,
  processedOnStep: Step.LandingPage,
  afterData: null,
  afterStep: null
};